<script setup lang='ts'>
import { ref } from 'vue'
import { Folder } from '@element-plus/icons-vue'

import { getQueryParams } from '@utopia-utils/core'
import { ElMessage } from 'element-plus'

import { downloadUrlQuery } from '@mp/api/downloadCenter/TaskController.ts'

import { statusMap } from './constant'

type Props = {
  item: APIDownloadCenter.TbDownloadQueryOwnerModel
}
const props = defineProps<Props>()

const loading = ref(false)

async function onClickDownload(item: APIDownloadCenter.TbDownloadQueryOwnerModel) {
  try {
    loading.value = true
    if (!item.downloadId)
      throw new Error('异常文件，无法下载')

    let fileUrl = ''
    try {
      const res = await downloadUrlQuery({
        downloadId: item.downloadId!,
      })
      if (res.resultCode === 'SUCCESS')
        fileUrl = res.downloadUrl || ''
    }
    catch (err) {
      console.error(err)
      ElMessage.error('异常文件，无法下载')
    }

    const queryParams = getQueryParams(fileUrl)

    if (!fileUrl || !queryParams.token)
      throw new Error('文件下载链接获取失败')

    window.open(fileUrl, '_self')

    // const resFile = await taskFileDownload({
    //   token: queryParams.token as string,
    // }, {
    //   responseType: 'blob',
    //   timeout: 1000 * 60 * 10,
    //   customOptions: {
    //     isReturnNativeResponse: true,
    //   },
    // })

    // const errMsg = await processFileStream(resFile, {
    //   type: 'application/zip',
    // })

    // if (errMsg)
    //   throw new Error(errMsg)

    // 下载成功后，乐观更新下载次数
    if (props.item)
      props.item.downloadCount! += 1
  }
  catch (err) {
    console.error(err)
    ElMessage.error('异常文件，无法下载')
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="flex item-start py-4 border-b border-b-n-40">
    <el-icon class="mr-2 mt-1">
      <Folder />
    </el-icon>
    <div class="flex-1 overflow-hidden">
      <div class="text-truncate" :title="item.fileName">
        {{ item.fileName || '-' }}
      </div>
      <div class="text-truncate text-xs text-[rgba(0,0,0,0.45)] inline-flex items-center gap-3">
        <span>创建时间：{{ item.createTime || '-' }}</span>
        <span>下载次数：{{ item.downloadCount }}</span>
        {{ statusMap[item.status as keyof typeof statusMap]?.tagColor }}
        <el-tag size="small" :type="statusMap[item.status as keyof typeof statusMap]?.tagColor === 'error' ? 'danger' : statusMap[item.status as keyof typeof statusMap]?.tagColor">
          {{ statusMap[item.status as keyof typeof statusMap]?.label || '-' }}
        </el-tag>
      </div>
    </div>
    <div>
      <el-button
        type="primary"
        :disabled="item.status !== '1'" link
        :loading="loading"
        @click="onClickDownload(item)"
      >
        下载
      </el-button>
    </div>
  </div>
</template>
